import Tags from './tags.vue';

export default Tags;


// WEBPACK FOOTER //
// ./src/components/inputs/tags/index.js